import { SvgIcon } from 'ui/icons/SvgIcon';
import { colors } from 'ui/theme/colors';

const SIZE = 6;
const VIEW_BOX = `0 0 ${SIZE * 2} ${SIZE * 2}`;

export const TEXT = {
  ACTIVE: 'Status: Active',
  INACTIVE: 'Status: Inactive',
};

export type Props = {
  active: boolean;
  className?: string;
};

export const StatusHint = ({ active, className }: Props) => {
  const fill = active ? colors.green100 : colors.textDisabled;
  const title = active ? TEXT.ACTIVE : TEXT.INACTIVE;

  return (
    <SvgIcon
      className={className}
      height={SIZE}
      width={SIZE}
      viewBox={VIEW_BOX}
      role="img"
      title={title}
    >
      <circle fill={fill} cx={SIZE} cy={SIZE} r={SIZE} />
    </SvgIcon>
  );
};
